import Navbar from '@/components/feature/Navbar';
import HeroSection from '@/components/feature/HeroSection';
import CategoryGrid from '@/components/feature/CategoryGrid';
import TrendingScroll from '@/components/feature/TrendingScroll';
import SEOIntro from '@/components/feature/SEOIntro';
import WhyUseSection from '@/components/feature/WhyUseSection';
import ArticleSpotlight from '@/components/feature/ArticleSpotlight';
import SafetySection from '@/components/feature/SafetySection';
import CTASection from '@/components/feature/CTASection';
import Footer from '@/components/feature/Footer';

const SITE_URL = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL as string) || 'https://superbuyspread.beer';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Superbuyspread',
  url: SITE_URL,
  description: 'Discover organized Superbuy spreadsheets, product guides, QC tips, comparison tools, and expert resources. Find the best Superbuy Spreadsheet links, shoes, hoodies, and clothing finds updated for 2026.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Superbuyspread',
  url: SITE_URL,
  description: 'The ultimate Superbuy Spreadsheet knowledge hub — helping shoppers discover, organize, and compare products through expertly curated spreadsheet resources.',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
  sameAs: ['https://kaspreadsheet.com'],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <main>
        <Navbar />
        <article>
          <HeroSection />
          <CategoryGrid />
          <TrendingScroll />
          <SEOIntro />
          <WhyUseSection />
          <ArticleSpotlight />
          <SafetySection />
          <CTASection />
        </article>
        <Footer />
      </main>
    </>
  );
}